<template>
  <div :class="['article-block', content.class]">
    <div v-html="openLinksInNewTab(content.contenthtml)"></div>

    <div class="article-flex-window" v-if="content.class == 'map-data'">
      <div class="article-flex" v-if="content.sections && content.sections.length">
        <div class="article-number" v-for="section in content.sections" :key="section.idSettingCompany">
          <span class="article-number-value">{{section.value}}</span>
          <span class="article-number-label">{{section.caption}}</span>
        </div>
      </div>
    </div>

    <template v-else>
      <div class="article-flex" v-if="content.sections && content.sections.length">
        <div class="article-number" v-for="section in content.sections" :key="section.idSettingCompany">
          <span class="article-number-value">{{section.value}}</span>
          <span class="article-number-label">{{section.caption}}</span>
        </div>
      </div>
      <template v-if="content.contacts && content.contacts.length">
        <div class="main-content-bottom-title">Contact</div>
        <div class="main-content-bottom">
          <div class="row">
            <ContactInfo v-for="contact in content.contacts" :key="contact.idContent" :contact="contact"></ContactInfo>
          </div>
        </div>
      </template>
    </template>

  </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
import ContactInfo from "@/components/persons/ContactInfo";
export default {
name: "HtmlContent",
components: {ContactInfo},
props: ['content'],
methods: {
  openLinksInNewTab: openLinksInNewTab,
},
}
</script>

<style scoped>

</style>
